// extracted by mini-css-extract-plugin
export default {"DeviceDetailsDialog":"DeviceDetailsDialog_DeviceDetailsDialog__ee301","LoadingContent":"DeviceDetailsDialog_LoadingContent__ahBhe"};